import { css } from "lit-element";

// language=CSS
export const TableStyle = css`
	:host {
		position: relative;
		display: block;
		min-height: 400px;
	}

	a {
		color: var(--app-primary);
		text-decoration: none;
	}

	h3 {
		margin-top: 0;
	}

	.table-header {
		font-weight: bold;
	}

	.table-row {
		position: relative;
		height: 50px;
		line-height: 50px;
		padding: 0 20px;
		border-radius: 5px;
		margin-bottom: var(--sw-page-table-row-margin-bottom, 5px);
		background-color: var(--app-white);
		overflow: hidden;
		text-overflow: ellipsis;

		display: flex;
		flex-wrap: wrap;
	}

	.table-content-row {
	}
	.table-content-row:hover {
		z-index: 1;
		box-shadow: 0 10px 40px var(--shadow-color, rgba(0, 0, 0, 0.15));
	}
	.table-header {
		overflow: visible;
	}

	.table-header-column,
	.table-column {
		padding: 0 10px;
		box-sizing: border-box;
		flex-grow: 1;
		display: block;
		width: 150px;
	}

	.table-column {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	button-outlined {
		margin: 10px auto;
	}
    
    .table-header-add-column {
        cursor: pointer;
        position: absolute;
        right:0;
    }
    
    .table-header-add-column:hover {
        background-color: var(--app-lightgrey);
    }
    
    .table-header-add-column sw-icon {
        margin: 20px;
        --sw-icon-width: 10px;
    }
`;
